import styled from 'styled-components';
import media from '../../constants/media';
import theme from '../../constants/theme';
import { A } from '../base/typography';

export const Wrapper = styled.div`
	display: flex;
	flex-wrap: wrap;
	font-family: ${theme.fonts.Arimo};
	color: ${theme.colorsV2.grey7};
	font-size: 16px;
	line-height: 20px;

	${media.mobileOnly`
		line-height: 16px;
	`};
`;

export const Breadcrumb = styled.div`
	display: flex;
	align-items: center;
`;

export const BreadcrumbLink = styled(A)`
	color: inherit;
	font-family: inherit;
`;

export const BreadcrumbLastLink = styled.span``;

export const BreadcrumbSep = styled.div`
	margin-inline: 16px;
`;
